'use strict';

module.exports = require('./Checkbox');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.4.4@rc-checkbox/lib/index.js
 ** module id = 164
 ** module chunks = 0 1
 **/